import React, {Component} from 'react';
import {Card, CardHeader, Row, Col, CardBody} from 'reactstrap';
import {Button, Dropdown} from "semantic-ui-react";
import apiConfig from "../../../axios/axios_api_services";
import axios_eventtag from "../../../axios/axios_eventtag";
import * as common from "../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action";
import {MDBDataTable} from "mdbreact";
import './Style.scss';
import * as DropDownConst from "../../../store/Reducer/DropDownConst";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";

class manageParticipant extends Component {
  state = {
    event_list: [],
    eventSubEvents: [],
    event_participant: [],
    subEventId: '',
    eventId: '',
    participantType: '', tempPrivacy: '',
    privacy: null
  };

  getEvents = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.CORPORATE_EVENTS({corporateId: corperateId}), {headers: headers})
      .then(async response => {
        if (response.data.success) {
          this.setState({event_list: response.data.eventList});
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getEvents();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  onChangeEventHandler = (e, {value}) => {
    let selectedEventObj = this.state.event_list.find(event => event.event_id === value);
    this.setState({
      eventId: value,
      subEventId: '',
      privacy: null,
      event_participant: [],
      participantType: '',
      tempPrivacy: selectedEventObj.privacy
    });
    this.getSubEvents(value);
  };

  getSubEvents = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.GET_SUBEVENT({event_id: id, corporateId:corperateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({eventSubEvents: response.data.subEventList});
        } else {
          this.setState({eventSubEvents: []})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getSubEvents(id);
        } else {
          this.props.spinnerHandler(false);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  onChangeSubeEventHandler = (e, {value}) => {
    this.setState({
      subEventId: value, privacy: this.state.tempPrivacy, participantType: '', event_participant: []
    });
  };
  onChangeApprovePendingHandler = (event, {value}) => {
    this.setState({
      participantType: value
    });
    this.getAllParticipantsUsingStatusOrSubEventId("PARTICIPANT_STATUS", value);
  };
  getAllParticipantsUsingStatusOrSubEventId = (type, value) => {
    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let participantStatus = type === "PARTICIPANT_STATUS" ? value : this.state.participantType;
    let subEventId = type === "SUBEVENT_ID" ? value : this.state.subEventId;
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.VIEW_PARTICIPANTS_ON_STATUS({
      sub_event_id: subEventId,
      status: participantStatus,
      corporateId:corperateId
    }), {headers: headers})
      .then(response => {

        if (response.data.success) {
          this.setState({event_participant: response.data.content});
        } else {
          this.setState({event_participant: []});
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllParticipantsUsingStatusOrSubEventId(type, value);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  onClickApproveRejectHandler = (value, type) => {
    let participantId = value.participant_id;
    let status = value.participantRequestStatus !== "APPROVED" ? "APPROVED" : "REJECTED";
    if (type) {
      status = type;
    }

    swal({
      title: "Are you sure you want to continue??",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":

          this.props.spinnerHandler(true);
          const headers = {
            "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
          };
          let corperateId = this.props.usr_obj.corporates[0].corporateId;
          axios_eventtag.patch(apiConfig.APPROVE_REJECT_PARTICIPANTS({
            participant_id: participantId,
            status: status,
            corporateId:corperateId
          }), {}, {headers: headers})
            .then(response => {

              common.notifyMessage(response.data.success ? "\"" + status + " \" Sucessfully" : response.data.message, response.data.success ? 2 : 0);
              if (response.data.success) {
                this.getAllParticipantsUsingStatusOrSubEventId();
              }
            })
            .catch(async error => {
              let result = await common.checkErrorResponse(error);
              if (result === 1) {
                this.onClickApproveRejectHandler(value, type);
              }
            })
            .finally(fin => {
              this.props.spinnerHandler(false);
            });
          break;
        default:
          break;
      }
    })
  };

  componentDidMount() {
    this.getEvents();
  }

  render() {
    let EventList = [];

    if (this.state.event_list.length !== 0) {
      this.state.event_list.map((value, index) => {
        EventList.push({
          text: value.event_name,
          value: value.event_id,
          key: value.event_id
        })
      })
    }

    let subEventList = [];
    if (this.state.eventSubEvents && this.state.eventSubEvents.length !== 0) {
      this.state.eventSubEvents.map((value, index) => {
        subEventList.push({
          text: value.name,
          value: value.sub_event_id,
          key: value.sub_event_id
        });
      });
    }
    let tblRows = [];
    this.state.event_participant && this.state.event_participant.map((value, index) => {
      tblRows.push({
        FirstName: value.userDTO.firstName,
        LastName: value.userDTO.lastName,
        Phone: value.userDTO.mobile,
        Email: value.userDTO.email,
        Action:
          <div>
            {
              value.participantRequestStatus === "APPROVED" ?
                <Button style={{backgroundColor: '#ec2f2f', color: "white"}}
                        onClick={(event) => this.onClickApproveRejectHandler(value, "REJECTED")}>Reject</Button>
                : value.participantRequestStatus === "REJECTED" ?
                <Button style={{backgroundColor: '#53bd52', color: "white"}}
                        onClick={() => this.onClickApproveRejectHandler(value, "APPROVED")}>Approve</Button>
                : <div>
                  <Button style={{backgroundColor: '#53bd52', color: "white"}}
                          onClick={() => this.onClickApproveRejectHandler(value, "APPROVED")}>Approve</Button>
                  <Button style={{backgroundColor: '#ec2f2f', color: "white"}}
                          onClick={() => this.onClickApproveRejectHandler(value, "REJECTED")}>Reject</Button>
                </div>

            }
          </div>
      })
    });

    return (
      <div className="event-org-dashboard">

        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            {
              this.props.usr_obj.userRoles === "CORP_EVENT_ORGANIZER" ?
                <h4 className={"route-name-style"}>{this.props.route_name}</h4>
                : <h4 className={"route-none-style"}/>
            }
            <Card className="card1">
              <CardHeader>
                Filter Events
              </CardHeader>
              <Col lg={12}>
                <Row className={"search-event-row"}>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Event'
                      fluid
                      search
                      selection
                      value={this.state.eventId}
                      options={EventList}
                      onChange={this.onChangeEventHandler}
                    />
                  </Col>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Sub Event'
                      fluid
                      search
                      selection
                      value={this.state.subEventId}
                      options={subEventList}
                      onChange={this.onChangeSubeEventHandler}/>
                  </Col>
                  <Col lg={4}>
                    <Dropdown
                      fluid
                      search
                      selection
                      placeholder={"Approved/Rejected/Pending"}
                      options={this.state.privacy ? this.state.privacy === "PUBLIC" ? DropDownConst.participantStatus : DropDownConst.private_participantStatus : []}
                      value={this.state.participantType}
                      onChange={this.onChangeApprovePendingHandler}
                    />
                  </Col>
                </Row>
              </Col>
            </Card>
            <Card>
              <CardHeader>
                Participants of Event
              </CardHeader>
              <CardBody>
                <MDBDataTable
                  striped
                  searching={true}
                  displayEntries={true}
                  paging={true}
                  entries={8}
                  responsive
                  responsiveSm
                  responsiveMd
                  responsiveLg
                  responsiveXl
                  bordered
                  hover
                  data={{rows: tblRows, columns: this.props.table_data.columns}}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  table_data: state.participantReducer.Event_Participant_Table_data
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(manageParticipant);

